/**
 * AnalyzeZoomButton : « Analyser la vue zoomée » d'un graphique de session.
 * N'apparaît qu'après un zoom ou un panoramique, et seulement si la page
 * accepte une période (onAnalyzeZoom). Seul ce bouton se rend à nouveau quand
 * la vue change, jamais le graphique (voir useChartZoomWindow).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BRAND } from '../constants/theme';
import { useZoomed } from './useChartZoomWindow';

export default function AnalyzeZoomButton({ zoom }) {
  const { t } = useTranslation();
  const zoomed = useZoomed(zoom.subscribe);
  if (!zoom.canAnalyze || !zoomed) return null;
  return (
    <button type="button" data-testid="analyze-zoom" onClick={zoom.analyzeZoom}
      style={{ padding: '6px 12px', fontSize: '12px', fontWeight: '600', borderRadius: '6px',
        background: 'transparent', color: BRAND.blueText, border: `1px solid ${BRAND.blue}`, cursor: 'pointer' }}>
      {t('charts.analyzeZoom')}
    </button>
  );
}
